import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import * as ImportantPersonsSelectors from './important-person.selectors';
import { ImportantPerson } from '@lyceo/homi/pupils/util-models';

@Injectable({
  providedIn: 'root',
})
export class ImportantPersonFacade {
  private readonly store: Store = inject(Store);

  public readonly paramPupilImportantPersons: Signal<ImportantPerson[]> =
    this.store.selectSignal(
      ImportantPersonsSelectors.selectParamPupilImportantPersons,
    );
}
